<template>
	<v-container id="regular-tables-view" fluid tag="section">
		<material-card icon="mdi-flower-tulip" icon-small title="لیست هزینه های صندوق" color="accent">
			<template v-slot:topActions>
				<v-btn color="primary" dark @click="add">
					<v-icon dark>
						mdi-plus-circle-outline
					</v-icon>
					افزودن هزینه کرد
				</v-btn>
			</template>
			<v-row>
				<v-col cols="12" style="padding:0 40px 40px">
					<v-row>
						<v-col cols="12" md="6">
							<v-text-field v-model="search" append-icon="mdi-magnify" label="اطلاعات مورد نظر خود جهت جستجو وارد کنید" single-line hide-details class="mb-5" />
						</v-col>
						<v-col cols="12">
							<v-data-table :headers="headers" :items="expenses" :items-per-page="500" :search="search" class="elevation-1">
								<template v-slot:item="row">
									<tr>
										<td>{{ row.item.title }}</td>
										<td class="text-center">
											{{ `${row.item.costDate_Persian.date}` }}
										</td>
										<td class="text-center">
											{{ row.item.amount.toString().toPriceFormat() }}
										</td>
										<td class="text-center">
											{{ `${row.item.saveDate_Persian.date}` }}
										</td>
										<td>
											{{ `${row.item.savedBy}` }}
										</td>
										<td class="text-center">
											<v-btn class="mx-1" fab dark small color="secondary" @click="edit(row.item)">
												<v-icon dark>
													mdi-square-edit-outline
												</v-icon>
											</v-btn>
											<v-btn class="mx-1" fab dark small color="pink" @click="remove(row.item)">
												<v-icon dark>
													mdi-trash-can-outline
												</v-icon>
											</v-btn>
										</td>
									</tr>
								</template>
							</v-data-table>
						</v-col>
					</v-row>
				</v-col>
			</v-row>
			<v-dialog v-model="dialogExpense" scrollable persistent max-width="600px">
				<v-card>
					<v-card-title>
						<span class="headline">مشخصات هزینه کرد</span>
						<v-spacer />
						<v-btn @click="dialogExpense = false" icon>
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text>
						<v-container>
							<modify-expense ref="modifyExpense" v-if="dialogExpense" :data="selectedExpense" @callbck="callbck" />
						</v-container>
					</v-card-text>
				</v-card>
			</v-dialog>
		</material-card>
		<confirm-dlg ref="confirm" />
		<div class="py-3" />
	</v-container>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import { emptyId } from '@/util/emptyId'
	import ModifyExpense from './ModifyExpense.vue'

	export default {
		name: 'MembersView',
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			'modify-expense': ModifyExpense,
		},
		data() {
			return {
				errorMessages: '',
				localData: {},
				selectedExpense: {},
				dialogExpense: false,
				search: '',
				headers: [
					{
						text: 'عنوان',
						align: 'start',
						sortable: true,
						value: 'title',
					}, {
						text: 'تاریخ',
						align: 'center',
						sortable: true,
						value: 'costDate_Persian',
					}, {
						text: 'مبلغ',
						align: 'center',
						sortable: true,
						value: 'amount',
					}, {
						text: 'تاریخ ایجاد',
						align: 'center',
						sortable: true,
						value: 'saveDate_Persian',
					}, {
						text: 'ثبت شده توسط',
						align: 'start',
						sortable: true,
						value: 'SavedBy',
					}, {
						text: 'عملیات ها',
						align: 'center',
						sortable: false,
						width: 150,
					},
				],
				expenses: [],
			}
		},
		mounted() {
			this.loadData()
		},
		methods: {
			loadData() {
				api.get('admin/expense/list', null)
					.then(
						response => {
							this.expenses = response
						})
					.catch(err => {
						toast.error(err.message)
					})
			},
			add() {
				this.dialogExpense = true
				this.selectedExpense = { id: emptyId }
			},
			edit(item) {
				this.dialogExpense = true
				this.selectedExpense = item
			},
			callbck(result) {
				this.dialogExpense = false
				if (result) { this.loadData() }
			},
			async remove(item) {
				if (!item) { return }

				if (await this.$refs.confirm.open(
					'توجه',
					'آیا از حذف این آیتم مطمئن هستید؟',
				)) {
					api.post('admin/expense/delete/' + item.id)
						.then(
							response => {
								toast.success('اطلاعات با موفقیت حذف شد.')
								this.loadData()
							})
						.catch(err => {
							toast.error(err.message)
						})
				}
			},
		},
	}
</script>
<style>
</style>
